import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./doorlock.css";

const { useAxios } = require("#api");

const DoorLock = (props) => {
  const { element, UID, Data } = props;
  const axiosInstance = useAxios();
  const [data, setData] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoadingImage, setIsLoadingImage] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setImageUrl(null);
  };
  useEffect(() => {
    const intervalId = setInterval(async () => {
      const response = await axiosInstance.post("/DeviceStat", {
        token: localStorage.getItem("token"),
        UID: UID,
      });
      if (response.data) {
        setData(response.data.Data);
      }
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [imageUrl]);
  
  
  
  
  
  

  function getCurrentDateTimeWithExtra30Seconds() {
    const now = new Date();
    return new Date(now.getTime() + 60000)
      .toISOString()
      .replaceAll("-", "/")
      .replace("T", " ")
      .replace("Z", "")
      .slice(0, 19);
  }

  const setDeviceState = async (value) => {
    try {
      const response = await axiosInstance.post("/SetDeviceStat", {
        token: localStorage.getItem("token"),
        UID: UID,
        Stat: `k1:${value ? true : false}`,
        Exp: getCurrentDateTimeWithExtra30Seconds(), // current datetime with extra 30 seconds with 2025/12/12 12:12:12 format
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  const getImage = async (value) => {
    try {
      setIsLoadingImage(true);
      setIsModalVisible(true);
  
      // Get image file
      const response = await fetch('http://server.kombosmart.ir:5000/api/GetImage', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: localStorage.getItem("token"),
          UID: UID,
        }),
      });
  
      // Check if the response is OK
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      // Get the response data as a binary response
      const blob = await response.blob();
  
      // Create an object URL from the blob
      const url = URL.createObjectURL(blob);
    
      setIsLoadingImage(false);
      // Set the image URL
      setImageUrl(url);
    } catch (error) {
      console.log("error", error);
    }
  };
  

  return (
    <>
      <Modal
        centered
        zIndex={999965}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
        className="responsive-modal doorlock-image-modal !w-screen md:!w-11/12 w-6/12 max-w-4xl h-dvh md:h-fit top-0 md:top-28"
      >
        {isLoadingImage && <div className="loader"></div>}
        {imageUrl && (
          <img src={imageUrl} alt="Image" className="max-w-full h-auto" />
        )}
      </Modal>
      <div className="flex flex-col justify-center items-center p-4 bg-white shadow rounded-md max-w-sm">
        <div
          className={`switchs grid grid-cols-2 w-full gap-4 p-4 ${
            (data === '00800000000000000000000000000000') ? "shake" : ""
          }`}
        >
          <div></div>
          <div
            className="switch h-24 w-24 bg-gray-500 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-600 text-white rounded-md"
            onClick={() => getImage()}
          >
            <svg
              width="40px"
              height="40px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="24" height="24" />
              <path
                d="M21 16V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V18M21 16V4C21 3.44772 20.5523 3 20 3H4C3.44772 3 3 3.44772 3 4V18M21 16L15.4829 12.3219C15.1843 12.1228 14.8019 12.099 14.4809 12.2595L3 18"
                stroke="#fff"
                stroke-linejoin="round"
              />
              <circle
                cx="8"
                cy="9"
                r="2"
                stroke="#fff"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div
            className="switch h-24 w-24 bg-gray-500 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-600 text-white rounded-md"
            onClick={() => setDeviceState(true)}
          >
            <svg
              width="40px"
              height="40px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.75736 10 5.17157 10 8 10H16C18.8284 10 20.2426 10 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16Z"
                stroke="#fff"
                stroke-width="1.5"
              />
              <path
                d="M12 14V18"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M6 10V8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8V10"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <div
            className="switch h-24 w-24 bg-gray-500 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-600 text-white rounded-md"
            onClick={() => setDeviceState(false)}
          >
            <svg
              width="40px"
              height="40px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.75736 10 5.17157 10 8 10H16C18.8284 10 20.2426 10 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16Z"
                stroke="#fff"
                stroke-width="1.5"
              />
              <path
                d="M6 10V8C6 4.68629 8.68629 2 12 2C14.7958 2 17.1449 3.91216 17.811 6.5"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M12 14V18"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
        {element.ShowName && <div className="name mt-2">{element.Name}</div>}
      </div>
    </>
  );
};

export default DoorLock;
